import React from 'react';
import ReactDOM from 'react-dom';
import FileView from 'Views/FileView';
import Controller from './Controller';

export default class FileController extends Controller {
  static boot() {
    Controller.boot(...arguments);
    FW.store.loaded('file', () => {
      window.File = FW.store.get('file');
      ReactDOM.render(
        <FileView file={window.File} />,
        document.getElementById('file-' + window.File.get('id'))
      );
      if (FW.inEditor()) window.parent.FW.editor.addType('file', window.File);
      FW.trigger('booted');
    });
  }
}
